import type { IAConfigData } from '$ops-portal/context/ia-database-context/iaDatabase.types';
import { IaDatabaseActionTypesEnum } from '$ops-portal/context/ia-database-context/iaDatabase.types';
import type { IAConfigAction } from './iaDatabaseConfig.types';

export const iaDatabaseConfigReducer = (
  state: IAConfigData,
  action: IAConfigAction
): IAConfigData => {
  switch (action.type) {
    case IaDatabaseActionTypesEnum.updateIaDatabaseConfig:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
